import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-container">
            <h1>Privacy Policy</h1>
            <div className="privacy-content">
                <section>
                    <h2>1. Information We Collect</h2>
                    <p>We collect information that you provide directly to us, including but not limited to:</p>
                    <ul>
                        <li>Name and contact information</li>
                        <li>Account credentials</li>
                        <li>Property information</li>
                        <li>Payment information</li>
                        <li>Communication preferences</li>
                    </ul>
                </section>

                <section>
                    <h2>2. How We Use Your Information</h2>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Provide and maintain our services</li>
                        <li>Process your transactions</li>
                        <li>Send you technical notices and support messages</li>
                        <li>Communicate with you about products, services, and events</li>
                        <li>Improve our services</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Information Sharing</h2>
                    <p>We may share your information with:</p>
                    <ul>
                        <li>Service providers who assist in our operations</li>
                        <li>Professional advisers</li>
                        <li>Law enforcement when required by law</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Data Security</h2>
                    <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
                </section>

                <section>
                    <h2>5. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your personal information</li>
                        <li>Correct inaccurate information</li>
                        <li>Request deletion of your information</li>
                        <li>Object to processing of your information</li>
                        <li>Data portability</li>
                    </ul>
                </section>

                <section>
                    <h2>6. Cookies and Tracking</h2>
                    <p>We use cookies and similar tracking technologies to track activity on our service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</p>
                </section>

                <section>
                    <h2>7. Children's Privacy</h2>
                    <p>Our service does not address anyone under the age of 18. We do not knowingly collect personally identifiable information from children under 18.</p>
                </section>

                <section>
                    <h2>8. Changes to This Policy</h2>
                    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "effective date" at the top of this Privacy Policy.</p>
                </section>

                <section>
                    <h2>9. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                    <ul>
                        <li>Email: privacy@rentlord.com</li>
                        <li>Phone: [Your Contact Number]</li>
                        <li>Address: [Your Business Address]</li>
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 